import React from 'react';
import OurServicesCard from '../OurServicesCard/OurServicesCard';

function SideOurServices() {
  return (
    <>
      <div className='h-72 md:h-96 lg:w-5/12 md:w-8/12 w-11/12 moveSVG'>
        <img
          src='https://firebasestorage.googleapis.com/v0/b/full-mark-app.appspot.com/o/Marketing%20consulting-pana.svg?alt=media&token=ab8396ba-b818-4acb-b785-0f93b8b00192'
          alt='imagehere'
          className='h-full w-full'
        />
      </div>

      <div
        className={`h-128 w-full lg:w-5/12 md:w-10/12 grid grid-cols text-textBlack `}
      >
        <OurServicesCard title='تقديم الحملات الإعلانية على جميع المنصات' />
        <OurServicesCard title='وضع خطط وإستراتيجيات ناجحة بالتسويق الإلكتروني' />
        <OurServicesCard title='إدارة صفحات السوشيال ميديا' />
        <OurServicesCard title='إنشاء قنوات يوتيوب وتقديم خطط تسويقية وحل المشكلات' />
        <OurServicesCard title='كتابة محتوى إبداعي' />
        <OurServicesCard title='إنشاء هويات بصرية للعلامات التجارية' />
        <OurServicesCard title='تصميم موشن جيرافيك' />
        <OurServicesCard title='تصميم جيرافيكي' />
      </div>
    </>
  );
}

export default SideOurServices;
